"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const GoogleLogo = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "google-logo", size: size, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, rest),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("path", { id: "a", d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" })),
            react_1.default.createElement("clipPath", { id: "b" },
                react_1.default.createElement("use", { xlinkHref: "#a", overflow: "visible" })),
            react_1.default.createElement("path", { clipPath: "url(#b)", fill: "#FBBC05", d: "M0 37V11l17 13z" }),
            react_1.default.createElement("path", { clipPath: "url(#b)", fill: "#EA4335", d: "M0 11l17 13 7-6.1L48 14V0H0z" }),
            react_1.default.createElement("path", { clipPath: "url(#b)", fill: "#34A853", d: "M0 37l30-23 7.9 1L48 0v48H0z" }),
            react_1.default.createElement("path", { clipPath: "url(#b)", fill: "#4285F4", d: "M48 48L17 24l-4-3 35-10z" }))));
};
exports.default = GoogleLogo;
//# sourceMappingURL=GoogleLogo.js.map